"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.incentiveTags = exports.amenityTags = exports.communityTypeTags = void 0;
exports.communityTypeTags = [
    { label: 'Small Town', value: 'smallTown' },
    { label: 'College Town', value: 'collegeTown' },
    { label: 'Mountain Town', value: 'mountainTown' },
    { label: 'Lake Town', value: 'lakeTown' },
    { label: 'Beach Town', value: 'beachTown' },
    { label: 'Big City', value: 'bigCity' },
    { label: 'Emerging City', value: 'emergingCity' },
    { label: 'Tech Town', value: 'techTown' },
    { label: 'Desert Town', value: 'desertTown' },
    { label: 'Historic Town', value: 'historicTown' },
];
exports.amenityTags = [
    { label: 'Outdoor Life', value: 'outdoorLife' },
    { label: 'Great Schools', value: 'greatSchools' },
    { label: 'Affordable', value: 'affordable' },
    { label: 'Family Friendly', value: 'familyFriendly' },
    { label: 'Winter Weather', value: 'winterWeather' },
];
exports.incentiveTags = [
    { label: 'Best', value: 'best' },
    { label: 'Featured', value: 'featured' },
    { label: 'Recruiting Now', value: 'recruitingNow' },
    { label: 'New', value: 'new' },
    { label: 'Popular', value: 'popular' },
    { label: 'Almost Gone', value: 'almostGone' },
];
